import { render, staticRenderFns } from "./CardRelatedAssets.vue?vue&type=template&id=32dcdc7a&scoped=true"
import script from "./CardRelatedAssets.vue?vue&type=script&lang=js"
export * from "./CardRelatedAssets.vue?vue&type=script&lang=js"
import style0 from "./CardRelatedAssets.vue?vue&type=style&index=0&id=32dcdc7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dcdc7a",
  null
  
)

export default component.exports